/**
 * Narrows down the type T of the given value by excluding types "null" and "undefined"
 */
export function assertNotNullish<T>(value: T | null | undefined, message?: string): asserts value is T {
  if (value === null) {
    throw new TypeError(message ? `${message} (got: null)` : 'Given value is null');
  } else if (value === undefined) {
    throw new TypeError(message ? `${message} (got: undefined)` : 'Given value is undefined');
  }
}

/**
 * Like assertNotNullish() but returns the value with the narrowed return type
 */
export function getNotNullish<T>(value: T | null | undefined, message?: string): T {
  assertNotNullish(value, message);
  return value;
}
